import { render, staticRenderFns } from "./sky-tabs.vue?vue&type=template&id=2183a0e8&scoped=true"
import script from "./sky-tabs.vue?vue&type=script&lang=js"
export * from "./sky-tabs.vue?vue&type=script&lang=js"
import style0 from "./sky-tabs.vue?vue&type=style&index=0&id=2183a0e8&prod&lang=scss&scoped=true"
import style1 from "./sky-tabs.vue?vue&type=style&index=1&id=2183a0e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2183a0e8",
  null
  
)

export default component.exports